package org.dronda.app.web.ui.components

import org.jetbrains.compose.web.css.StyleSheet

object ComponentStyles : StyleSheet() {
   init {
       buttonStyles()
   }
}